/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol extends models.ServiceAccountCredentialsBaseForKubernetesClusterAws {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol>): ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol(), model);
        ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol>): ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol.newInstance(<ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForKubernetesClusterAws.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForKubernetesClusterAwsAccessKeyProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Access Key Id. This is a required field.
     */
    access_key: string;

    /**
     * Secret Access Key Id. This is a required field.
     */
    secret_key: string;

}
